import Skeleton from '@mui/material/Skeleton';
import { FlexBox } from '../layout';

interface SectionSkeletonProps {
  rows?: number;
}

const SectionSkeleton: React.FC<SectionSkeletonProps> = ({ rows = 2 }) => (
  <FlexBox
    border={(theme) => `1px solid ${theme.palette.gray?.[300]}`}
    borderRadius={4}
    p={3}
    flexDirection="column"
    gap={3}
  >
    {Array.from({ length: rows }, (_, i) => (
      <FlexBox key={i} gap={3} alignItems="center">
        <Skeleton sx={{ width: 70, height: 70 }} />
        <FlexBox flexDirection="column" gap={1} flex={1}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="30%" />
        </FlexBox>
      </FlexBox>
    ))}
  </FlexBox>
);

export default SectionSkeleton;
